import { render, staticRenderFns } from "./discount-coupons.vue?vue&type=template&id=674ffe7e&"
import script from "./discount-coupons.vue?vue&type=script&lang=js&"
export * from "./discount-coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports